import { render, staticRenderFns } from "./TradeOrderInfo.vue?vue&type=template&id=2380c7ac&scoped=true&"
import script from "./TradeOrderInfo.vue?vue&type=script&lang=js&"
export * from "./TradeOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./TradeOrderInfo.vue?vue&type=style&index=0&id=2380c7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380c7ac",
  null
  
)

export default component.exports